import * as XLSX from "xlsx";
import { format } from "date-fns";

export function exportToExcel({dataExcel}){
    console.log(dataExcel);    
    
    // const workbook = XLSX.utils.book_new();
    // XLSX.utils.book_append_sheet(workbook, worksheet, "Ventas");

    const data = dataExcel.map(e => ({
        Codigo: e.idItem,
        Nombre: e.name,
        Descripcion: e.description,
        Stock: e.stock,
        Stock_Total: e.stockTotal,
        Valor: e.value        
    }));

    
    const dataExcels = XLSX.utils.json_to_sheet(data);

    dataExcels["!cols"] = [
        { wch: 10 },
        { wch: 40 },
        { wch: 80 },
        { wch: 10 },  
        { wch: 10 },
        { wch: 15 },        
    ];

    const filaFinal = data.length + 3;
    // dataExcels[`H${filaFinal}`] = { t: "s", v: "TOTAL VENTAS:" };
    // dataExcels[`I${filaFinal}`] = { t: "n", v: totalDoc };

    const rango = XLSX.utils.decode_range(dataExcels["!ref"]);
    rango.e.r = filaFinal - 1;
    dataExcels["!ref"] = XLSX.utils.encode_range(rango);

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, dataExcels, "Articulos");    
    XLSX.writeFile(workbook, "Articulos.xlsx");
    
};
